import { createAsyncThunk } from '@reduxjs/toolkit';

import { fetchWrapper } from '../../../../helpers';
import { TREATMENT_PLANS_V2_API_BASE } from '../../constants';

import type {
  IDischargeReason,
  ITreatmentPlanV3DischargePage,
  GetTreatmentPlanV3DischargePagePayload,
  UpdateTreatmentPlanV3DischargeCriteriaPayload,
  CreateTreatmentPlanV3DischargeReasonPayload,
  DeleteTreatmentPlanV3DischargeReasonPayload,
} from './types';

export function createTreatmentPlanV3DischargeThunks() {
  return {
    getTreatmentPlanV3DischargePage: getTreatmentPlanV3DischargePage(),
    updateTreatmentPlanV3DischargeCriteria: updateTreatmentPlanV3DischargeCriteria(),
    createTreatmentPlanV3DischargeReason: createTreatmentPlanV3DischargeReason(),
    deleteTreatmentPlanV3DischargeReason: deleteTreatmentPlanV3DischargeReason(),
  };
}

function getTreatmentPlanV3DischargePage() {
  return createAsyncThunk<ITreatmentPlanV3DischargePage, GetTreatmentPlanV3DischargePagePayload>(
    'treatmentPlanV3/getTreatmentPlanV3DischargePage',
    async ({ treatmentPlanId, getAccessTokenSilently }) =>
      fetchWrapper.get({
        url: `${TREATMENT_PLANS_V2_API_BASE}/${treatmentPlanId}/pages/discharge/`,
        getAccessTokenSilently,
      }),
  );
}

function updateTreatmentPlanV3DischargeCriteria() {
  return createAsyncThunk<
    ITreatmentPlanV3DischargePage,
    UpdateTreatmentPlanV3DischargeCriteriaPayload
  >(
    'treatmentPlanV3/updateTreatmentPlanV3DischargeCriteria',
    async ({ treatmentPlanId, data, getAccessTokenSilently }) =>
      fetchWrapper.patch(
        {
          url: `${TREATMENT_PLANS_V2_API_BASE}/${treatmentPlanId}/pages/discharge/`,
          getAccessTokenSilently,
        },
        data,
      ),
  );
}

function createTreatmentPlanV3DischargeReason() {
  return createAsyncThunk<IDischargeReason, CreateTreatmentPlanV3DischargeReasonPayload>(
    'treatmentPlanV3/createTreatmentPlanV3DischargeReason',
    async ({ treatmentPlanId, data, getAccessTokenSilently }) =>
      fetchWrapper.post(
        {
          url: `${TREATMENT_PLANS_V2_API_BASE}/${treatmentPlanId}/pages/discharge/reasons/`,
          getAccessTokenSilently,
        },
        data,
      ),
  );
}

function deleteTreatmentPlanV3DischargeReason() {
  return createAsyncThunk<void, DeleteTreatmentPlanV3DischargeReasonPayload>(
    'treatmentPlanV3/deleteTreatmentPlanV3DischargeReason',
    async ({ treatmentPlanId, reasonId, getAccessTokenSilently }) => {
      await fetchWrapper.delete({
        url: `${TREATMENT_PLANS_V2_API_BASE}/${treatmentPlanId}/pages/discharge/reasons/${reasonId}/`,
        getAccessTokenSilently,
      });
    },
  );
}
